export const moneyMaskPrefixed = 'separator.2';
